import { connect } from 'react-redux'

import { makeGetOrders, makeGetSelectedOrder } from '../../selectors/order'
import OrdersList from '../../components/orders/List'
import { selectOrder } from '../../actions/order'

const mapStateToProps = (state) => {
  const getOrders = makeGetOrders()
  const orders = getOrders(state)

  const getSelectedOrder = makeGetSelectedOrder()
  const selectedOrder = getSelectedOrder(state) || {}

  return {
    orders,
    selectedOrderId: selectedOrder.uuid,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSelectOrder: (orderId) => dispatch(selectOrder(orderId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrdersList)
